import { getRosterList } from 'services/axios/roster'

export const actions = {
  GET_ROSTER_LIST: 'GET_ROSTER_LIST',
  HANDLE_PAGINATION: 'HANDLE_PAGINATION',
  HANDEL_ROSTER_YEAR: 'HANDEL_ROSTER_YEAR',
  HANDEL_ROSTER_EMP_SEARCH: 'HANDEL_ROSTER_EMP_SEARCH',
  HANDEL_ROSTER_MONTH: 'HANDEL_ROSTER_MONTH',
}

// Action creators
export const handlePagination = (pagination) => {
  return {
    type: 'HANDLE_PAGINATION',
    payload: pagination,
  }
}

export const getListOfRoster = ({
  skip,
  limit,
  searchEmp,
  month,
  year,
  locationId,
  ...extraParams
}) => {
  return async (dispatch) => {
    const response = await getRosterList(
      skip,
      limit,
      searchEmp,
      month,
      year,
      locationId,
      extraParams,
    )
    if (response?.status === 200 && response?.data?.message === 'success') {
      dispatch({
        type: actions.GET_ROSTER_LIST,
        payload: {
          rosterList: response?.data?.data?.rosterList || [],
          totalCount: response?.data?.data?.totalCount,
        },
      })
    }
  }
}
export const handleYear = (year) => {
  return {
    type: 'HANDEL_ROSTER_YEAR',
    payload: year,
  }
}
export const handleSearchEmployee = (emp) => {
  return {
    type: 'HANDEL_ROSTER_EMP_SEARCH',
    payload: emp,
  }
}
export const handleMonth = (emp) => {
  return {
    type: 'HANDEL_ROSTER_MONTH',
    payload: emp,
  }
}
